module.exports = require('date-fns/startOfMonth').startOfMonth;
